export default {
  sections: {
    setup_fee: {
      title: 'Käyttöönottokustannukset',
      description: 'Käyttöönottokustannukset alkaen {{amount}} – sen sijaan että yli 1000',
    },
  },
  labels: {
    month: 'Kuukausi (NETTO)',
    one_time_fee: 'Kertamaksu',
    more_options: 'Lisää vaihtoehtoja',
    discount_badge: '-{{percentage}}%',
  },
  features: {
    app: 'Oma sovelluksesi App Storessa ja Google Playssa',
    push_notifications: 'Push-ilmoitukset tarjouksista',
    loyalty: 'Asiakasuskollisuus kanta-asiakasohjelmien avulla',
    offline_orders: 'Offline-tilaukset mahdollisia',
    individual_design: 'Yksilöllinen sovellussuunnittelu',
  },
  setup_fee_options: {
    150: 'Vakiokäyttöönotto',
    75: 'Alennettu',
    0: 'Ei perustamiskuluja',
  },
  feedback: {
    contract_signed_already: {
      title: 'Sopimus on jo allekirjoitettu',
      description: 'Ota yhteyttä tekniseen tukeen, jos tarvitset muutoksia',
    },
  },
};
